<template>
  <section>
    <div class="q-mt-sm">
      <q-table
        title="Detalhes das Molas & Esteiras ou Compartilhamentos"
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        class="tabela-tamanho-fixo tabela-quebra-texto"
        :columns="columns"
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        dense
        @request="handleRequest"
      >
        <template #body-cell-atualizar="props">
          <q-td>
            <q-btn
              color="positive"
              round
              class="q-ml-sm"
              icon="check"
              @click="
                setMachineStock(props.row.id, props.row.pivot.minimal_stock)
              "
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </section>
</template>

<script>
const columns = [
  {
    name: "posicao",
    label: "# Posição",
    field: "number",
    align: "left",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: (row) => row.product?.code,
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: (row) => row.product?.description || row.product?.name,
    align: "left",
    style: "max-width: 400px; white-space: normal; word-wrap: break-word;",
    headerStyle: "max-width: 400px;",
  },

  {
    name: "amount",
    label: "Quantidade",
    field: "amount",
    align: "left",
  },

  {
    name: "max_amount",
    label: "Quantidade Max Posição",
    field: "max_amount",
    align: "left",
  },
  {
    name: "minimal_stock",
    label: "Quantidade Min Posição",
    field: "minimal_stock",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
export default {
  props: ["atualizar"],
  setup(props) {
    const store = useStore();
    const nameQr = ref("");

    const $q = useQuasar();
    const route = useRoute();
    const rows = ref([]);
    const disable = ref(true);

    const paramsRota = JSON.parse(route.params.id);
    let filter = ref("");

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getMachine = async () => {
      let response = await store.dispatch("maquina/getMachine", {
        id: paramsRota.id,
      });

      rows.value = response.data.results.slots;

      disable.value = false;
    };

    const setMachineStock = async (id, minimal_stock) => {
      try {
        await store.dispatch("maquina/setMachineStock", {
          id: id,
          minimal_stock,
        });

        $q.notify({
          message: "Estoque minimo alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getMachine();
      } catch (error) {
        $q.notify({
          message: "Erro a o alterar stock minimo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      getMachine();
    };

    onMounted(getMachine);

    const handleRequest = async () => {
      getMachine(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getMachine();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getMachine();
      }
    );

    return {
      columns,
      rows,
      getMachine,
      pagination,
      handleRequest,
      disable,
      filter,
      nameQr,

      setMachineStock,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      paramsRota,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}

.tabela-quebra-texto :deep(td) {
  white-space: normal !important;
  word-wrap: break-word !important;
}

.tabela-quebra-texto :deep(td.q-table--col-auto-width) {
  white-space: normal !important;
}
</style>
